import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const steps = [{
  id: 1,
  label: 'STEP 01',
  title: 'Search for local business owners',
  description: 'Find business owners by industry and location. Openmart matches your search criteria against 200M+ local businesses to surface the decision-makers you need to reach.',
  image: 'https://cdn.magicpatterns.com/uploads/gV7JHHXgbCBdaBrQXT1vTQ/Search_Filter.gif',
  alt: 'Openmart owner finder search interface with industry and location filters'
}, {
  id: 2,
  label: 'STEP 02',
  title: 'Get verified owner contact details',
  description: 'Instantly access verified email addresses and direct phone numbers for local business owners. Every contact is matched and validated before delivery.',
  image: 'https://cdn.magicpatterns.com/uploads/4E8XS6hq3erKBoQYVewHu3/Enrichment_Results.gif',
  alt: 'Openmart showing verified owner emails and phone numbers for local businesses'
}, {
  id: 3,
  label: 'STEP 03',
  title: 'Reach out directly',
  description: 'Export your owner contact lists to CSV, sync to your CRM, or launch personalized email sequences directly from Openmart. Start conversations with the people who make decisions.',
  image: 'https://cdn.magicpatterns.com/uploads/rVM4aRBJZ2GReXm9ucPQ7R/ExportCRM_Sync.gif',
  alt: 'Openmart outreach and export options for business owner contacts'
}];
export function OwnerFinderProductTour() {
  return <section className="py-40 bg-white relative overflow-hidden" data-id="element-6043">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-6044">
        <div className="text-center max-w-3xl mx-auto mb-32" data-id="element-6045">
          <div className="text-sm font-bold text-blue-600 tracking-widest uppercase mb-4" data-id="element-6046">
            Product Tour
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight tracking-tight" data-id="element-6047">
            See the <span className="text-blue-600" data-id="element-6048">product in action</span>
          </h2>
          <p className="text-xl text-slate-500 leading-relaxed" data-id="element-6049">
            From search to verified owner contacts in minutes.
          </p>
        </div>

        <div className="space-y-36 md:space-y-52" data-id="element-6050">
          {steps.map((step, index) => {
          const isEven = index % 2 !== 0;
          return <div key={step.id} className={`flex flex-col ${isEven ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-16 lg:gap-28 items-center`} data-id="element-6051">
                <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.7,
              delay: 0,
              ease: [0.25, 0.1, 0.25, 1]
            }} className="w-full lg:w-5/12 space-y-8" data-id="element-6052">
                  <div className="text-sm font-bold text-slate-400 tracking-widest uppercase" data-id="element-6053">
                    {step.label}
                  </div>
                  <h3 className="text-3xl md:text-4xl font-bold text-slate-900 tracking-tight leading-tight" data-id="element-6054">
                    {step.title}
                  </h3>
                  <p className="text-lg text-slate-500 leading-relaxed" data-id="element-6055">
                    {step.description}
                  </p>
                  <div className="pt-2" data-id="element-6056">
                    <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-blue-600 font-semibold hover:text-blue-700 transition-colors group" data-id="element-6057">
                      Try for free
                      <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-6058" />
                    </a>
                  </div>
                </motion.div>

                <motion.div initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-100px'
            }} transition={{
              duration: 0.7,
              delay: 0.15,
              ease: [0.25, 0.1, 0.25, 1]
            }} className="w-full lg:w-7/12" data-id="element-6059">
                  <div className="w-full rounded-2xl overflow-hidden shadow-xl ring-1 ring-black/5" data-id="element-6060">
                    <img src={step.image} alt={step.alt} className="w-full h-auto block" loading="lazy" data-id="element-6061" />
                  </div>
                </motion.div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}